import { ArrowUp, ExternalLink } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";
import { COTTAGES, SECTIONS } from "../../data/cottages";
import { Wordmark } from "./Header";
import { Wildflowers } from "./Ornaments";
import { Otter } from "./SmalandDetails";
import { scrollToId } from "./scroll";

export const Footer = () => {
  const { t, lang } = useLang();
  const go = (e, id) => {
    e.preventDefault();
    scrollToId(id);
  };
  return (
    <footer className="footer" data-testid="site-footer">
      <Wildflowers className="footer__flowers" />
      <Otter className="smaland-otter" />
      <div className="wrap footer__grid">
        <div className="footer__brand">
          <Wordmark light testId="footer-wordmark" onClick={(e) => go(e, "hem")} />
          <p className="script footer__tagline">{t.footer.tagline}</p>
        </div>
        <div>
          <h4 className="footer__title">{t.footer.cottagesTitle}</h4>
          <ul className="footer__list">
            {COTTAGES.map((c) => (
              <li key={c.key}>
                <a href={c.booking[lang]} target="_blank" rel="noopener noreferrer" data-testid={`footer-booking-link-${c.key}`}>
                  {c.name} <span className="footer__muted">{t.footer.onBooking}</span>
                  <ExternalLink size={13} strokeWidth={1.6} aria-hidden="true" />
                  <span className="sr-only">({t.cottages.newTab})</span>
                </a>
                <span className="footer__addr">{c.address}</span>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="footer__title">{t.footer.pageTitle}</h4>
          <ul className="footer__list footer__list--nav">
            {SECTIONS.map(({ id, key }) => (
              <li key={id}>
                <a href={`#${id}`} onClick={(e) => go(e, id)} data-testid={`footer-nav-${id}`}>{t.nav[key]}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="wrap footer__bottom">
        <p data-testid="footer-note">{t.footer.note}</p>
        <p data-testid="footer-copyright">© {new Date().getFullYear()} Vimmerbyferie</p>
        <button type="button" className="footer__top" onClick={() => scrollToId("hem")} data-testid="footer-back-to-top">
          {t.footer.top}
          <ArrowUp size={14} strokeWidth={1.6} aria-hidden="true" />
        </button>
      </div>
    </footer>
  );
};
